import { useSyncExternalStore as e } from "react";
function o(t) {
  return e(t.subscribe, t.getSnapshot, t.getSnapshot);
}
export { o as useStore };